export const transactionUpload=`<p><strong>Navigation</strong>:&nbsp; Payments / Transaction Upload</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/19/1.png' /></p>
<p><strong>Overview</strong></p>
<p>Lloyds Bank Gem Connect offers the functionality to upload a payment file via the site.&nbsp;</p>
<p>The supported payment types are:</p>
<ul>
<li>Faster Payment</li>
<li>Multiple Faster Payments</li>
<li>Bacs Payment</li>
<li>Multiple Bacs Payments</li>
<li>CHAPS Payment</li>
<li>SEPA Credit Transfer</li>
<li>International Payment</li>
<li>Inter-group transfer</li>
</ul>
<p>Key points to consider when using this functionality:</p>
<ul>
<li>Multiple Faster Payments and Multiple Bacs Payments are Single Debit Multi Credit payment types &ndash; so one debit account and multiple beneficiary accounts are specified in the import file. Per upload, a minimum of 2 credits and a maximum of 1000 credits are supported.&nbsp;</li>
<li>The other payment types are Single Debit Single Credit payment types. Per upload, a maximum of 1000 individual payments/transfers are supported.</li>
<li>The file format must be in CSV or XML format and align to the associated Lloyds Bank template (further details below).</li>
<li>Each file uploaded will be validated and actioned based on the method of payment selected.</li>
<li>You will need to ensure your user role profiles include entitlements for &lsquo;Upload file transactions&rsquo; and the entitlement to manage the associated payment type &ndash; i.e.&nbsp; &lsquo;Manage faster payment&rsquo;, &lsquo;Manage CHAPS payment&rsquo; etc, as necessary.</li>
<li>If the file is not in the correct format or has missing or invalid information, this will result in the file not being accepted into the system.&nbsp;</li>
<li>If the file import is successful or partially successful, the valid payments are created. Thereafter, these imported payments may be edited or viewed in the same way as payments created via the Gem Connect create payment screens.</li>
<li>Similarly, imported payments are approved on the Approvals / Pending approvals / Transactions screen, individually or on a per page basis, as per payments created via the Gem Connect create payment screens.</li>
<li>On the Approvals / Pending approvals / Transactions screen, for imported payments, the Payment source field holds the name of the file used to create the payment, so the approver can see all the payments successfully imported via a particular file.</li>
</ul>
<p>&nbsp;</p>
<p><strong>Transaction Upload: </strong></p>
<p>On selecting Transaction upload, the following screen is displayed:</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/19/2.png' /></p>
<p>Press Upload to progress to the Step 1 screen.</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/19/3.png' /></p>
<p>Click on the Method of payment drop down to select the required payment type.</p>
<p>Click on the File type drop down to select the required File type.</p>
<p>For Multiple Faster Payments and Multiple Bacs Payments, you will additionally have the Batch booking option. If Batch booking is checked, this will result in one debit being made against the debit account for the sum of the credits (see  <strong>Make a Faster Payment </strong> section or <strong> Make a Bacs Payment</strong> section for further details).</p>
<p>Multiple Bacs Payments also have the Confidential payments option (see <strong> Make a Bacs Payment</strong> section for further details).</p>
<p>Click on Browse to select a file for upload and then press Validate.&nbsp;</p>

<div class='row'>
<div class='col-8'>
<p> If the file fails initial validation, the <strong>Step 2</strong> screen will display a list of errors.</p>
<p>If the file passes initial validation, the Step 2 screen will display the Number of payments in the file.</p>
<p>If the number of payments displayed is correct and you with to proceed with the import, press Submit. Otherwise you can press Cancel to stop the import or Edit to go back to Step 1.</p>

</div>
<div class='col-4'>
<p><img src='${process.env.PUBLIC_URL}/images/4/19/4.png' /></p>
</div>
</div>


<div class='row'>
<div class='col-8'>
<p>Upon Submit, the <strong>Step 3</strong> screen is displayed.</p>
<p>Click Done.</p>
</div>
<div class='col-4'>
<p><img src='${process.env.PUBLIC_URL}/images/4/19/5.png' /></p>
</div>
</div>
<p>The system will take you back to the <strong>Transaction upload summary</strong> screen where you will see your most recently imported payment file at the top.</p>
<p>Additional secondary validation of your imported payment file now takes place, in the background (e.g. to validate Beneficiary Sort Code, Beneficiary Bank BIC, Beneficiary IBAN etc). The <strong>Transaction upload summary</strong> screen Status column conveys the result of the secondary validation:</p>
<ul>
<li><strong>Status</strong> = <strong>In process</strong> – this is an interim status which is displayed whilst the secondary validation is taking place. (Click on the Search spyglass icon to refresh the Status).</li>
<li><strong>Status</strong> = <strong>Success</strong> – all the payments have been created and can be viewed by navigating to Payments summary > Pending payments.</li>
<li><strong>Status</strong> = <strong>Fail</strong> – none of the payments have been created. Clicking Details against the file will display all the errors. The import file must be corrected and then imported again.</li>
<li><strong>Status</strong> = <strong>Partial success</strong> – some of the payments have been created and some have not. Clicking Details against the file will display all the errors for the payments which have not been created. The import file must be edited to remove the successful payments, correct those that have failed and then imported again.</li>
</ul>
<p><strong>Further Information: Transaction File Upload Fields</strong></p>
<p>For further details on the file formats, please refer to the <strong>Transaction Upload Message Interface Guide</strong> available from the Onboarding &amp; Servicing Team.</p>

`;


// WEBPACK FOOTER //
// ./src/components/content/payments/19-transactionUploads.ts